const   modalOpen = document.querySelectorAll('.modal-open'),
        modalClose = document.querySelectorAll('.close-modal'),
        modalFixer = document.querySelector('.modal-position-fix'),
        modalBackground = modalFixer.querySelector('.modal-background'),
        allModals = document.querySelectorAll('.modal-wrapper');

        slideArray = [...document.querySelectorAll('.avancees-collectives-slider .slider-item-wrap')],
        originalLength = document.querySelectorAll('.avancees-collectives-slider .slider-item-wrap:not(.clone)').length,
        offset = document.querySelectorAll('.avancees-collectives-slider .clone').length / 2

modalOpen.forEach(el => {

    el.addEventListener('click', (event) => {

        const backWidth = Math.max(window.innerHeight, window.innerWidth) / 20
        
        // Positionning the background on top of the cursor
        const leftPos = event.clientX - backWidth, topPos = event.clientY - backWidth
        modalBackground.style.left = `${leftPos}px`;
        modalBackground.style.top = `${topPos}px`;

        document.body.classList.add('modal-active');
        
        const isInterview = el.classList.contains('interview-open');
        let targetModal = modalFixer.querySelector('.interview-modal')

        // Not clicking on the interview button
        if(!isInterview) {
            targetModal.style.display = 'none';
            targetModal = modalFixer.querySelector('.default-modal');
            targetModal.scrollTo(0, 0);

            const currentSlide = el.closest('.slider-item-wrap');
            const slideId = slideArray.indexOf(currentSlide);

            const modalId = (slideId - offset) % originalLength
            targetModal.querySelector('.modal-content').children[modalId].dataset.active = true
        } else {
            document.querySelectorAll('.default-modal').forEach(modal => modal.style.display = 'none');
        }

        targetModal.dataset.active = true;
    });

});

modalClose.forEach(el => {

    el.addEventListener('click', () => {
        document.body.classList.remove('modal-active');
        allModals.forEach(modal => {
            modal.style.display = 'block';
        })

        const activeModals = modalFixer.querySelectorAll('[data-active="true"]');
        
        activeModals.forEach(e => {
            const pageContent = e.classList.contains('modal-page')

            if(pageContent) {
                const activeVideos = e.querySelectorAll('iframe');

                activeVideos.forEach(video => {      
                    const videoSrc = video.src
                    video.src = videoSrc;
                });
            }

            e.dataset.active = false
        });
    });

});

const modalNav = (modal, dir) => {
    const modalPages = [... modal.querySelectorAll('.modal-page')], currentPage = modal.querySelector('.modal-page[data-active="true"]')

    let index = modalPages.indexOf(currentPage) + dir;
    if(index < 0) {
        index = modalPages.length - 1
    } else if (index >= modalPages.length) {
        index = 0
    }

    // Stopping videos
    const activeVideos = currentPage.querySelectorAll('iframe');
    activeVideos.forEach(video => {      
        const videoSrc = video.src
        video.src = videoSrc;
    });

    const targetScroll = currentPage.closest('.modal-wrapper');
    targetScroll.scrollTo(0, 0);

    currentPage.dataset.active = false;
    modalPages[index].dataset.active = true;
    modalFixer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

const modalNext = modalFixer.querySelectorAll('.next-modal'), modalPrev = modalFixer.querySelectorAll('.prev-modal')

modalNext.forEach( el => el.addEventListener( 'click', () => modalNav(modalFixer, 1) ) );
modalPrev.forEach( el => el.addEventListener( 'click', () => modalNav(modalFixer, -1) ) );